<rask-tree-selector
  [label]="texts.produktgrupper"
  [placeholder]="texts.produktgrupperplaceholder"
  class="productgroup-component"
  (change)="updateSelectedProduktgruppList()"
  [items]="allProduktgrupper"
  [required]="false"
aid="filterSkogligDataProduktgrupper"></rask-tree-selector>

<div class="selected-productgroups">
  @if (selectedProduktgrupper?.length ) {
    <div class="productgroup-header-row">
      <div class="productgroup-row">
        <div class="dummy-component-for-header">
          <fieldset>
            <label>
              {{texts.produktgrupp}}
            </label>
          </fieldset>
        </div>
        <div class="dummy-component-for-header float-end">
          <fieldset>
            <label>
              {{texts.minstavolym}}
            </label>
          </fieldset>
        </div>
      </div>
    </div>
  }
  @for (grupp of selectedProduktgrupper; track grupp; let i = $index) {
    <div class="productgroup-row">
      <div class="productgroup-name">{{grupp.namn}}</div>
      <rask-input-number aid="filterSkogligDataVolym_{{i}}" class="m3fub-input" placeholder="m3fub" [min]="0" [step]="1"
      [(ngModel)]="grupp.volym"></rask-input-number>
    </div>
  }
</div>

@if (hasMoreThanOneProduktGrupp()) {
  <div>
    <rask-radiobutton-group class="vertical produktgrupp" [buttons]="boolskaoperationer"
      [(ngModel)]="searchFilter.skogligdata.produktgrupperBool">
    </rask-radiobutton-group>
  </div>
}